import React, {Component} from 'react';
import AutoPartNewItemPopup from './AutoPartNewItemPopup'
import FontAwesome from 'react-fontawesome'

class AutoPartTable extends Component {
  constructor(...args){
    super(...args)
    this.state = {checkedAll:false,show:false}
  }

  renderTableRow(){
    let {itemList} = this.props
    if(itemList.length===0){
      return (<tr><td colSpan={3}>No Item Found...</td></tr>)
    }
    return itemList.map((item,index)=>(
      <tr key={index} className={"data-row "+(item.checked?'bg-green':'')} >
        <td className="data-column itemnum" style={{display:'none'}}>204</td>
        <td className="data-column text-center" >
        <input className="cbItemPart" type="checkbox" name="cbItemPart"
          checked={(typeof item.checked!=='undefined')?item.checked:false}
          onChange={this.onCheck.bind(this,index)}/>
        </td>
        <td className="data-column itemdescription">{item.description}</td>
        <td className="data-column itemdescription2">{item.description_en}</td>
      </tr>
    ))
  }

  onAllCheck(e){
    this.setState({checkedAll:!this.state.checkedAll})
    this.props.onAllCheck(!this.state.checkedAll)
  }

  onCheck(index,e){
    console.log('onCheck',index,e)
    this.props.onCheck(index)
  }

  onNewItemClick(){
    this.setState({show:true})
  }


  render(){
    let {show} = this.state
    let {carType,subCatId,subCatPos} = this.props
    return (
      <div className="part_content_table">
        <table className='table table-responsive table-bordered-solid table-hover table-autopart' >
          <thead>
          <tr className="headDtg" >
            <th className='text-center' >
              <input type="checkbox"  checked={this.state.checkedAll} onChange={this.onAllCheck.bind(this)}/>
            </th>
            <th >Description</th>
            <th >Description(en)</th>
          </tr>
          </thead>
          <tbody>
            {this.renderTableRow()}
          </tbody>
        </table>
        <button className="btn  bg-olive " onClick={this.onNewItemClick.bind(this)}><FontAwesome name='plus'/>New Item</button>
        <AutoPartNewItemPopup show={show} carType={carType} subCatId={subCatId} subCatPos={subCatPos}
          onSave={this.props.onSave}
          onHide={()=>{this.setState({show:false})}}/>
      </div>
    )
  }
}

export default AutoPartTable



// WEBPACK FOOTER //
// ./src/view/autoparts/AutoPartTable.js